/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Base(props) {
  const { nodes, materials } = useGLTF('/models/Base.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Base.geometry}
        position={[0, -166.18, 0]}
      >
        {' '}
        <meshPhysicalMaterial color={'white'} roughness={0.8} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Base.glb')
